import React from 'react';
import PropTypes from 'prop-types';
import SearchHighlight from '../SearchHighlight';

const Title = ({ contact, searchTerm }) => {
  const {
    user: { fullNameWithTitle },
  } = contact;

  return searchTerm ? (
    <SearchHighlight text={fullNameWithTitle} toHighlight={searchTerm} />
  ) : (
    fullNameWithTitle
  );
};

Title.defaultProps = {
  searchTerm: '',
};

Title.propTypes = {
  contact: PropTypes.shape({
    user: PropTypes.shape({
      fullNameWithTitle: PropTypes.string,
    }).isRequired,
  }).isRequired,
  searchTerm: PropTypes.string,
};

export default Title;
